module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dadSa"))).then(() => parcelRequire('f4eak'));